module.exports = __webpack_public_path__ + "static/media/IMG_0280.93fe1163.jpg";